import React, { useContext, useRef } from "react";
import "./index.css";
import { NavLink, useNavigate } from "react-router-dom";
import { clearStorage, getStorageItem } from "../../utils/sessionStorage";
import { useState } from "react";
import axios from "axios";
import { useEffect } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { toast } from "react-toastify";
import Run from "../../components/posts/run";
import { useDispatch } from "react-redux";
import { PathAction } from "../../redux/reducers/globalPath";
import AppContext from "../../context/AppContext";

const Coin = () => {
  const navigate = useNavigate();
  // User Information
  const accessToken = getStorageItem("token");
  const userId = getStorageItem("user_id");
  // Runs
  const [runs, setRuns] = useState(500);
  const [displayRuns, setDisplayRuns] = useState(0);
  const [insufficientRuns, setInsufficientRuns] = useState(false);
  const [notEligible, setNotEligible] = useState(false);
  const [choice, setChoice] = useState(false);
  const [spin, setSpin] = useState(false);
  const [result, setResult] = useState({
    coinResultOption: "",
    userSelectedOption: "",
    entryRun: "",
    rewardedRun: "",
  });
  // const [nextGameTime, setNextGameTime] = useState("");
  const [output, setOutput] = useState(false);
  const [isSpinning, setIsSpinning] = useState(false);
  const videoRef = useRef(null);
  const [audio, setAudio] = useState(false);
  // Handle time left
  // const handleTimeLeft = (mongooseDate) => {
  //   const lastPlayTime = moment(mongooseDate);
  //   const now = moment();
  //   const sparsedTime = now.diff(lastPlayTime);
  //   const timeLeft = moment.duration(4, "hours").subtract(sparsedTime);
  //   console.log(sparsedTime, timeLeft);
  //   let hours = Math.floor(timeLeft.as("hours"));
  //   let minutes = timeLeft.minutes();
  //   let seconds = timeLeft.seconds();
  //   setNextGameTime(
  //     hours + " hours " + minutes + " minutes, " + seconds + " seconds"
  //   );
  // };
  // Spinning of coin
  const handleCoinFlip = () => {
    setAudio(true);
    setTimeout(() => {
      setSpin(false);
      setOutput(true);
    }, 4000);
  };
  // Check User Runs
  const getRuns = () => {
    if (!accessToken) return;
    if (!userId) return console.error("userId required");
    const getTotalRun = {
      method: "GET",
      url: global.config.ROOTURL.prod + "/pitch/getTotalRun/" + userId,
      headers: {
        Authorization: "Bearer " + accessToken,
      },
    };
    axios(getTotalRun)
      .then((response) => {
        setDisplayRuns(response.data);
      })
      .catch((error) => {
        console.log("6")
       console.log(error)
      });
  };
  // Check Eligibility
  const checkEligibility = async () => {
    if (!runs || typeof runs !== "number") {
      toast.error("Invalid entry runs");
      return;
    }
    if (runs < 50 || runs > 5000) {
      toast.error("Runs should be between 50 to 5000");
      return;
    }

    if (runs > displayRuns) {
      setInsufficientRuns(true);
      return;
    }
    if (!accessToken) return;
    let eligibilityOptions = {
      method: "GET",
      url: global.config.ROOTURL.prod + `/contest/coinToss/checkEligibility`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: "Bearer " + accessToken,
      },
    };
    await axios(eligibilityOptions)
      .then((response) => {
        if (response.data.eligible === false) {
          setNotEligible(true);
          // handleTimeLeft(response?.data.lastTimePlayed);
          return;
        }
        if (response?.status == 200) {
          setChoice(true);
        }
      })
      .catch((error) => {
        console.log("Creation error" + error);
        if (error?.response?.status == 500) {
          setNotEligible(true);
          console.log(error);
        }
      });
  };
  // Choice
  const handleChoice = async (choice) => {
    if (!runs || typeof runs !== "number") {
      console.log("Invalid entry runs");
      return;
    }
    if (runs < 50 || runs > 5000) {
      toast.error("Runs should be between 50 to 5000");
      return;
    }
    if (runs > displayRuns) {
      setInsufficientRuns(true);
      return;
    }
    if (runs && choice) {
      let choiceOptions = {
        method: "POST",
        url: global.config.ROOTURL.prod + `/contest/coinToss/start-playing`,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: "Bearer " + accessToken,
        },
        data: {
          userSelectedOption: choice,
          entryRun: runs,
        },
      };
      await axios(choiceOptions)
        .then((response) => {
          if (response?.status === 200) {
            setChoice(false);
            setResult({
              coinResultOption: response?.data.coinResultOption,
              userSelectedOption: response?.data.userSelectedOption,
              entryRun: response?.data.entryRun,
              rewardedRun: response?.data.rewardedRun,
            });
            setSpin(true);
            handleCoinFlip();
          }
        })
        .catch((error) => {
          console.log("Creation error" + error);
          if (error?.response?.status === 500) {
            console.log(error);
          }
        });
    }
  };
  const path = window.location.pathname;
  const dispatch = useDispatch();
  dispatch(PathAction.handlePath({ payload: path }));

  const appContext = useContext(AppContext);
  const { setShowFooter } = appContext;

  useEffect(() => {
    getRuns();
    setShowFooter(true);
    return () => {
      setShowFooter(false);
    };
  }, []);
  // useEffect
 
  useEffect(() => {
    if (insufficientRuns || notEligible || choice || spin || output) {
      document.body.style.overflow = "hidden"; // Prevent scrolling of body
      window.scrollTo(0, 0); // Set scroll position to top
    } else {
      document.body.style.overflow = "auto"; // Set body overflow back to normal
    }

    return () => {
      document.body.style.overflow = "auto"; // Set body overflow back to normal when unmounting
    };
  }, [insufficientRuns, notEligible, choice, spin, output]);
  useEffect(() => {
    const audioFile = new Audio("/audio/coin-toss.mp3");
    if (audio) {
      audioFile.play();
      setTimeout(() => {
        setAudio(false);
      }, 2000);
    }
  }, [audio]);

  return (
    <div className="wrapper-coin">
      {/* Modal--insufficient */}
      {insufficientRuns ? (
        <div className="modal--insufficient-coin">
          <AiOutlineCloseCircle
            className="close__icon-output-coin"
            onClick={() => {
              setInsufficientRuns(false);
            }}
          />
          <div className="modal__wrapper--insufficient-coin">
            <div className="out__wrapper-coin">
              <img
                src="/svg/out.svg"
                alt="insuffiecient-runs"
                className="insufficient__out-coin"
              />
            </div>
            <div className="insufficient__content-coin">
              <p>Sorry , You have insuffiecient Runs</p>
              <img
                src="/svg/sad-face.svg"
                alt="sad-face"
                className="face--sad-coin"
              />
            </div>
          </div>
        </div>
      ) : null}
      {/* Modal--notEligible */}
      {notEligible ? (
        <div className="modal--insufficient-coin">
          <AiOutlineCloseCircle
            className="close__icon-output-coin"
            onClick={() => {
              setNotEligible(false);
            }}
          />
          <div className="modal__wrapper--insufficient-coin">
            <div className="out__wrapper-coin">
              <img
                src="/svg/out.svg"
                alt="insuffiecient-runs"
                className="insufficient__out-coin"
              />
            </div>
            <div className="insufficient__content-coin">
              <p className="small__text--chance-exceeded-coin">
                You have already played 1 time in the last 4 hours.
              </p>
              <img
                src="/svg/sad-face.svg"
                alt="sad-face"
                className="face--sad-coin"
              />
            </div>
          </div>
        </div>
      ) : null}
      {/* Modal--side */}
      {choice ? (
        <div className="modal--side-coin">
          <div className="side__main-coin">
            <div className="side--choose-coin">
              <img
                src="/svg/helmet.svg"
                alt="helmet"
                className="helmet--left-coin"
              />
              <img
                src="/svg/helmet.svg"
                alt="helmet"
                className="helmet--right-coin"
              />
            </div>
            <div className="side--choices-coin">
              <div
                className="options--box-coin"
                onClick={() => {
                  handleChoice("Heads");
                }}
              >
                <img
                  src="/svg/coin-front.svg"
                  alt="heads"
                  className="choose__coin-coin"
                />
                <p className="option__name-coin">Heads</p>
              </div>
              <div
                className="options--box-coin"
                onClick={() => {
                  handleChoice("Tails");
                }}
              >
                <img
                  src="/svg/coin-back.svg"
                  alt="heads"
                  className="choose__coin-coin"
                />
                <p className="option__name-coin">Tails</p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {/* Modal--spin */}
      {spin ? (
        <div className="modal--spin-coin">
          <div className="spin__backdrop-coin">
            <div className="spin__result-coin">
              {result?.userSelectedOption === "Heads" ? (
                <img
                  src="/svg/coin-front.svg"
                  alt="coin-front"
                  className="spin__heads-coin"
                />
              ) : (
                <img
                  src="/svg/coin-back.svg"
                  alt="coin-back"
                  className="spin__tails-coin"
                />
              )}
              <p className="spin__text-coin">{result?.userSelectedOption}</p>
            </div>
            {result?.coinResultOption === "Heads" && (
              <div className="coin--main">
                <audio id="coin-sound">
                  <source src="/audio/coin-toss.mp3" type="audio/mp3" />
                  Your browser does not support the audio element.
                </audio>
                <img
                  src="/svg/coin-back.svg"
                  alt="coin-back"
                  className="coin-back"
                />
                <img
                  src="/svg/coin-front.svg"
                  alt="coin-front"
                  className="coin-front"
                />
              </div>
            )}
            {result?.coinResultOption === "Tails" && (
              <div className="coin--main">
                <audio id="coin-sound">
                  <source src="/audio/coin-toss.mp3" type="audio/mp3" />
                  Your browser does not support the audio element.
                </audio>
                <img
                  src="/svg/coin-front.svg"
                  alt="coin-front"
                  className="coin-front"
                />
                <img
                  src="/svg/coin-back.svg"
                  alt="coin-back"
                  className="coin-back"
                />
              </div>
            )}
          </div>
        </div>
      ) : null}
      {/* Output */}
      {output ? (
        <div className="modal--output-coin">
          <AiOutlineCloseCircle
            className="close__icon-output-coin"
            onClick={() => {
              setOutput(false);
              navigate("/rewards");
            }}
          />
          {result && result?.coinResultOption === result?.userSelectedOption ? (
            <img
              src="/svg/crown.svg"
              alt="crown"
              className="output__crown-coin"
            />
          ) : null}
          <div className="output__header-coin">
            <div className="header--left-coin"></div>
            <div className="header--center-coin">
              <p className="header__text-coin">
                {result &&
                result?.coinResultOption === result?.userSelectedOption
                  ? "Congratulations"
                  : "Sorry"}
              </p>
            </div>
            <div className="header--right-coin"></div>
          </div>
          <div className="output__main-coin">
            <p className="output__message-coin">
              {result && result?.coinResultOption === result?.userSelectedOption
                ? "You Won"
                : "You Lose"}
            </p>
            <div className="output__center-coin">
              {result &&
              result?.coinResultOption === result?.userSelectedOption ? (
                <img
                  src="/svg/pass.svg"
                  alt="pass"
                  className="output__face-coin"
                />
              ) : (
                <img
                  src="/svg/fail.svg"
                  alt="fail"
                  className="output__face-coin"
                />
              )}
              <p className="output__runs-coin">
                {result &&
                result?.coinResultOption === result?.userSelectedOption
                  ? result?.rewardedRun
                  : 0}
              </p>
            </div>
            <p className="output__message--last-coin">Come back again</p>
            <button className="output__next-coin">4:00 Hours</button>
          </div>
        </div>
      ) : null}
      <div className="heading__box-coin">
        <h1 className="toss__heading-coin">Toss Ka Boss</h1>
        <h3 className="toss__subheading-coin">Win 2x Runs</h3>
        <div className="subheading__underline-coin"></div>
      </div>
      <div className="content-coin">
        <div className="user__runs--total-coin">
          <div className="dot--red-coin"></div>
          {/* <p>{displayRuns}</p> */}
          <Run isRunValueNeeded={true} />
        </div>
        <img
          src="/svg/coin-front.svg"
          alt="coin-front"
          className="coin__image-coin"
        />
        <div className="runs-coin">
          <p className="runs__detail-coin">Enter Run</p>
          <input
            type="number"
            className="runs__entered-coin"
            value={runs.toString()}
            onChange={(event) => {
              setRuns(parseInt(event.target.value));
            }}
            min={50}
            max={5000}
          />
          <div className="minmax-coin">
            <p className="runs--min-coin">Min 50</p>
            <p className="runs--max-coin">Max 5000</p>
          </div>
        </div>
        <div className="choose-coin">
          {[50, 500, 5000].map((num, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  setRuns(num);
                }}
              >
                <img
                  src="/svg/runs-wrapper.svg"
                  className="runs__box-coin"
                  alt="runs-wrapper"
                />
                <p className="runs__direct-coin">{num}</p>
              </div>
            );
          })}
        </div>
        <div className="runs__slider-coin">
          <input
            type="range"
            className="slider-coin"
            min="0"
            max="100"
            value={Math.round(((runs - 50) / 4950) * 100)}
            onChange={(event) =>
              setRuns(
                Math.round((parseInt(event.target.value) / 100) * 4950 + 50)
              )
            }
          />
        </div>
      </div>
      <button className="submit__toss-coin" onClick={checkEligibility}>
        Flip Now
      </button>
    </div>
  );
};

export default Coin;
